import React, { useState } from "react";

import { css } from "@emotion/react";
import { CSS_MQ } from "../../styles/breakpoints";

import cn from "classnames";
import { ContentContainer } from "../_shared-components/arrangement/Container";
import { AccordionImage } from "./AccordionImage";
import { ContentfulComponentCMSHook } from "@swo/shared";
import { AccordionItemType, ComponentAccordionType } from "@swo/storefront";
import { getComponentCMSClassname } from "../cms/edit-overlay/component-hook-class";
import { AccordionElement } from "./AccordionElement";

export function AccordionComponent(props: ComponentAccordionType & ContentfulComponentCMSHook) {
  const { accordionItemsCollection, image } = props;

  const [activeItem, setActiveItem] = useState(accordionItemsCollection[0]);

  const openAccordion = (item: AccordionItemType) => {
    setActiveItem(item);
  };

  return (
    <ContentContainer className={getComponentCMSClassname(props?.sys?.id)}>
      <div
        className={cn(props.width === "Wide" ? "wide" : "narrow", image ? "with-image" : undefined)}
        css={wrapperStyles}
      >
        {image && <AccordionImage image={image} width={props.width} />}

        <div
          css={css`
            .narrow > & {
              width: 100%;

              ${CSS_MQ.atLeastMd} {
                width: 50%;
              }
            }
            .wide > & {
              width: 100%;
            }
          `}
        >
          {accordionItemsCollection.map((ai, idx) => (
            <AccordionElement
              key={ai.descriptiveHeadline}
              ai={ai}
              onClick={ai !== activeItem ? () => openAccordion(ai) : undefined}
            />
          ))}
        </div>
      </div>
    </ContentContainer>
  );
}

const wrapperStyles = css`
  display: flex;
  align-items: center;
  flex-direction: column;

  &.with-image.wide {
    flex-wrap: wrap;
  }

  ${CSS_MQ.atLeastSm} {
    flex-direction: row;
  }

  ${CSS_MQ.atLeastLg} {
    padding: 0 100px;
  }
`;
